import React from 'react';
import { useTranslation } from 'react-i18next';

import { H1 } from '@/components/Typography/Typography';

import handshake from '/img/icons/handshake.png';

interface prop {
  setOpen: (e: boolean) => void;
}

const IfNoGroups: React.FC<prop> = ({ setOpen }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="ifNoGroups">
        <H1>{t('Friends')}</H1>
        <img src={handshake} alt="handshake" width={77} />
        <div>
          <p>
            {t(
              'Join friend group via invitation link or create your own group and unite friends',
            )}
          </p>
          <p>
            {t(
              'Follow your friends progress: help them speed up resource extraction or take some for yourself. Playing together is always more fun!',
            )}
          </p>
          <p>
            {t(
              'A group of friends is a closed community of up to 50 people. For a larger open community, create or join a squad',
            )}
          </p>
        </div>
      </div>
      <button
        type="button"
        className="btn"
        style={{ width: '100%' }}
        onClick={() => setOpen(true)}
      >
        {t('Create group')}
      </button>
    </>
  );
};

export default IfNoGroups;
